export async function getPreferredImmersiveSessionMode(xr) {
  if (!xr?.isSessionSupported) {
    return null;
  }

  try {
    if (await xr.isSessionSupported("immersive-vr")) {
      return "immersive-vr";
    }

    if (await xr.isSessionSupported("immersive-ar")) {
      return "immersive-ar";
    }
  } catch (error) {
    return null;
  }

  return null;
}

export function getXrEnterLabel(sessionMode) {
  return sessionMode === "immersive-ar" ? "Enter XR" : "Enter VR";
}
